import { Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';

// project import
import Loader from './Loader';

// Error fallback component
const ErrorFallback = ({ error, resetErrorBoundary }) => (
    <div role="alert" style={{ padding: '20px', textAlign: 'center' }}>
        <h2>Something went wrong:</h2>
        <pre style={{ color: 'red' }}>{error.message}</pre>
        <button onClick={resetErrorBoundary}>Try again</button>
    </div>
);

// ==============================|| LOADABLE - LAZY LOADING ||============================== //

const Loadable = (Component) => (props) =>
    (
        <ErrorBoundary FallbackComponent={ErrorFallback} onReset={() => window.location.reload()}>
            <Suspense fallback={<Loader />}>
                <Component {...props} />
            </Suspense>
        </ErrorBoundary>
    );

export default Loadable;
